import * as lottie from 'lottie-web/build/player/lottie.js';
import scrollama from 'scrollama';
import { mobileStickyAnimationObsv } from './intersectionObservers';
import { eventThrottle } from '../../../utility';
import { serversAniConfig, serverLightsAniConfig } from './animations/animationConfigs.js';

const $graphic = document.querySelector('.scroll__graphic');
const $text = document.querySelector('.scroll__text');
const $steps = $text.querySelectorAll('.scroll__step > div');

// initialize the scrollama
const scroller = scrollama();
let isInitialLoad = true;

// These are the time segments for the labToConsumer Animations
// that correspond to the text captions on the right.
const labToConsumerAniSegments = [
  [0, 20],
  [80, 420],
  [420, 640],
  [640, 860],
];

// Load Server animations. Wait for the first animation to complete before
// beginning the subsequent downloads.
const labToConsumerAni = lottie.loadAnimation(serversAniConfig);
labToConsumerAni.setSpeed(2);

// Load Server Lights animation
labToConsumerAni.addEventListener('data_ready',
  () => lottie.loadAnimation(serverLightsAniConfig));


// start it up
init();
initMobile();

/**
 * Function Defenitions Below. Function Calls Above.
 */

// scrollama event handlers
function handleStepEnter({ index, direction }) {
  if (labToConsumerAniSegments[parseInt(index)]) {
    const segments = labToConsumerAniSegments[parseInt(index)];
    labToConsumerAni.playSegments(segments, true);
  }

  // BUGFIX: On the initial load of the page, there is a bug where the steps get triggered
  // in the wrong order. I can't tell what is causing this, but it might have to do with
  // how quickly the CSS gets applied. The issue is seen on Scrollama's demos.
  // This checks the following conditions the bug is known to appear in before employing the fix.
  // Conditions:
  // - initial load of the page
  // - downward scroll is detected
  // - the last $step is above the center of the page
  // Solution:
  // Under these conditions, the graphic will _sometimes_ remain sticky,
  // so we manually call releaseElement().
  if (isInitialLoad && direction === 'down') {
    if ($steps[$steps.length - 1].getBoundingClientRect().top < window.innerHeight/2) {
      releaseElement($graphic, direction);
    }
  }

}

function handleContainerEnter() {
  document.body.classList.add('scroll__snap-enabled');
  freezeElement($graphic);
}

function handleContainerExit({direction}) {
  document.body.classList.remove('scroll__snap-enabled');
  releaseElement($graphic, direction);
}

// kick-off code to run once on load
function init() {
  scroller
    .setup({
      container: '#scroll', // our outermost scrollytelling element
      graphic: '.scroll__graphic', // the graphic
      text: '.scroll__text', // the step container
      step: '.scroll__text .scroll__step', // the step elements
      offset: 0.7, // set the trigger to be 1/2 way down screen
      debug: false, // display the trigger offset for testing
    })
    .onStepEnter(handleStepEnter)
    .onContainerEnter(handleContainerEnter)
    .onContainerExit(handleContainerExit);

  window.addEventListener('resize', () => eventThrottle(handleResize(), 200));

  setTimeout(() => {
    isInitialLoad = false;
    handleResize();
  }, 1000);

}

// kick-off code to run once on load
function initMobile() { // 1. call a resize on load to update width/height/position of elements
  const observer = mobileStickyAnimationObsv(labToConsumerAni, labToConsumerAniSegments);
  [...$text.querySelectorAll('.scroll__step')].forEach(step => {
    observer.observe(step);
  });
}

function freezeElement(element) {
  const bounding = element.getBoundingClientRect();

  // sticky the graphic
  element.classList.add('is-fixed');
  element.classList.remove('is-bottom');
  element.style.width = `${bounding.width}px`;
  element.style.left = `${bounding.left}px`;
}


function releaseElement(element, direction) {
  // un-sticky the graphic, and pin to top/bottom of container
  element.classList.remove('is-fixed');
  if (direction === 'down') element.classList.add('is-bottom');
  element.style.width = null;
  element.style.left = null;
}

function handleResize() {
  scroller.resize();
  if (isLargerThanMobile()) {
    scroller.enable();
  }
  else {
    scroller.disable();
    releaseElement($graphic);
  }
}

function isLargerThanMobile() {
  return window.matchMedia('(min-width: 750px)').matches;
}
